export class AccountModel {
    username: string = "";
    password: string = "";
    device_name: string = "test";
}

export class TokenModel {
    auth_token: string;
    token_type: string;
    expires_in: number;
}

export class UserModel {
    id: string;
    agency_id: string;
    name: string;
    address: string;
    email: string;
    email_verified_at: string;
    api_token: string;
    user_type: string;
    menuroles: string;
    status: string;
    last_signin: string;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    permissions: any;
    is_student: boolean;
    is_staff: boolean;
}

export class AuthResponseModel {
    token: TokenModel;
    user: UserModel;
    profile_image?: string;

    constructor() {
        this.token = new TokenModel(),
        this.user = new UserModel(),
        this.profile_image = null;
    }
}

